import React, { useCallback, useState } from "react"

import { Input } from "@heroui/react"

interface SipAddressInputProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  className?: string
  error?: string
}

export const SipAddressInput: React.FC<SipAddressInputProps> = ({
  value,
  onChange,
  disabled = false,
  error,
  className = "",
}) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = useCallback(() => setIsFocused(true), [])
  const handleBlur = useCallback(() => setIsFocused(false), [])

  const showError = !isFocused && value.length > 0 && !!error

  return (
    <div className="w-full">
      <Input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder="sip:user@example.com"
        className={className}
        isInvalid={!!showError}
      />
      {showError && (
        <p className="text-tiny text-coval-danger-text mt-1">
          Please enter a valid SIP address (e.g. sip:user@example.com)
        </p>
      )}
    </div>
  )
}
